<h5>{{ header() }}</h5>

@if(skeletonWidth())
{
    <p-skeleton [width]="skeletonWidth()!"/>
}